import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
  IconButton,
  Tooltip,
  CircularProgress,
  Typography,
  Popover,
  Stack,
  FormControl,
  TextField,
  InputAdornment,
  MenuItem,
  Autocomplete,
} from '@mui/material';
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { bulkUploadTask } from '../../../../services/taskService';
import ProtectedComponent from '../../../../components/protected/ProtectedComponent';
import Iconify from '../../../../components/iconify';
import CustomPopover, { usePopover } from '../../../../components/custom-popover';

// const VisuallyHiddenInput = styled('input')({
//   clip: 'rect(0 0 0 0)',
//   clipPath: 'inset(50%)',
//   height: 1,
//   overflow: 'hidden',
//   position: 'absolute',
//   bottom: 0,
//   left: 0,
//   whiteSpace: 'nowrap',
//   width: 1,
// });

const ProjectListToolbar = ({
  filters,
  onFilters,
  //
  dateError,
  projectOption,
  setProjectName,
}) => {
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);

  const popover = usePopover();

  const handleGlobalFilter = useCallback(
    (event) => {
      onFilters('globalFilter', event.target.value);
    },
    [onFilters]
  );

  const handleFilterStartDate = useCallback(
    (newValue) => {
      const date = new Date(newValue);
      console.log('date', date, 'newValue', newValue);
      onFilters('startDate', date);
    },
    [onFilters]
  );

  const handleFilterEndDate = useCallback(
    (newValue) => {
      const date = new Date(newValue);
      onFilters('endDate', date);
    },
    [onFilters]
  );

  const handleFileUpload = async (event) => {
    const files = event?.target?.files;

    if (!files || files.length === 0) {
      return;
    }

    const file = files[0];

    setLoading(true);
    try {
      const response = await bulkUploadTask(file);
      if (response.status === 200) {
        toast.success(response?.data?.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.errors?.[0]?.message || 'Error while uploading file');
    } finally {
      setLoading(false);
      event.target.value = ''; // safer than null
    }
  };

  const handleIconClick = () => {
    fileInputRef.current.click();
  };

  const handleExportData = () => {
    const taskList = [
      {
        Name: 'Demo 1',
        ClassificationName: '',
        Description: '',
        Project_Name: 'project 1',
        Task_Type: 'task',
        Assigned_To: 'example@ex.com',
        Start_Date: '01/01/2023',
        End_Date: '01/02/2023',
        Section: 'To Do',
        Status: 'Not Started',
        Planned_Hours: '3',
        Client_Name: 'client 1',
        Parent_Task: '',
        Issue_Priority: '',
        Is_Parent: 'No',
      },
      {
        Name: 'Demo 2',
        ClassificationName: '',
        Description: '',
        Project_Name: 'project 2',
        Task_Type: 'issue',
        Assigned_To: 'example@ex.com',
        Start_Date: '01/01/2023',
        End_Date: '01/01/2023',
        Section: 'In progress',
        Status: 'Not Started',
        Planned_Hours: '3',
        Client_Name: 'client 1',
        Parent_Task: 'Demo 1',
        Issue_Priority: 'Low',
        Is_Parent: 'No',
      },
      {
        Name: 'Demo 3',
        ClassificationName: '',
        Description: 'Issue description',
        Project_Name: 'project 2',
        Task_Type: 'issue',
        Assigned_To: 'example@ex.com',
        Start_Date: '01/01/2023',
        End_Date: '01/01/2023',
        Section: 'To Do',
        Status: 'In Progress',
        Planned_Hours: '3',
        Client_Name: 'client 1',
        Parent_Task: 'Demo 1',
        Issue_Priority: 'Medium',
        Is_Parent: 'No',
      },
      {
        Name: 'Demo 4',
        ClassificationName: '',
        Description: '',
        Project_Name: 'project 2',
        Task_Type: 'issue',
        Assigned_To: 'example@ex.com',
        Start_Date: '01/01/2023',
        End_Date: '01/01/2023',
        Section: 'To Do',
        Status: 'Not Started',
        Planned_Hours: '3',
        Client_Name: 'client 1',
        Parent_Task: 'Demo 1',
        Issue_Priority: 'High',
        Is_Parent: 'No',
      },
      {
        Name: 'Demo 5',
        ClassificationName: '',
        Description: '',
        Project_Name: 'project 2',
        Task_Type: 'cr',
        Assigned_To: 'example@ex.com',
        Start_Date: '01/01/2023',
        End_Date: '01/01/2023',
        Section: 'To Do',
        Status: 'Not Started',
        Planned_Hours: '3',
        Client_Name: 'client 1',
        Parent_Task: '',
        Issue_Priority: 'Low',
        Is_Parent: 'No',
      },
    ];

    // Create a new workbook and worksheet
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(taskList);

    // Format the Start_Date and End_Date columns as dates
    taskList.forEach((task, index) => {
      const rowIndex = index + 2; // Data starts from the second row

      // Convert string to date object
      const startDateParts = task.Start_Date.split('/');
      const endDateParts = task.End_Date.split('/');
      const startDate = new Date(startDateParts[2], startDateParts[1] - 1, startDateParts[0]);
      const endDate = new Date(endDateParts[2], endDateParts[1] - 1, endDateParts[0]);

      // Set the date value and format the cell
      ws[`F${rowIndex}`] = { t: 'd', v: startDate, z: 'dd/mm/yyyy' };
      ws[`G${rowIndex}`] = { t: 'd', v: endDate, z: 'dd/mm/yyyy' };
    });

    XLSX.utils.book_append_sheet(wb, ws, 'Tasks');
    XLSX.writeFile(wb, 'add_task_template.xlsx');
  };
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const handleFilterProjectName = useCallback(
    (event, newValue) => {
      onFilters('projectName', newValue);
    },
    [onFilters]
  );

  // const handleFilterProjectNameChange = useCallback(
  //   (event, newInputValue) => {
  //     setProjectName(newInputValue);
  //   },
  //   [onFilters]
  // );

  return (
    <>
      <Stack
        spacing={2}
        alignItems={{ xs: 'flex-end', md: 'center' }}
        direction={{
          xs: 'column',
          md: 'row',
        }}
        sx={{
          p: 2.5,
          pr: { xs: 2.5, md: 1 },
        }}
      >
        {/* <FormControl
          sx={{
            flexShrink: 0,
            width: { xs: 1, md: 180 },
          }}
        >
          <Autocomplete
            options={projectOption}
            value={filters.projectName}
            onChange={(event, newValue) => handleFilterProjectName(event, newValue)}
            onInputChange={(event, newInputValue) => handleFilterProjectNameChange(event, newInputValue)}
            renderInput={(params) => (
              <TextField {...params} label="Project" variant="outlined" sx={{ textTransform: 'capitalize' }} />
            )}
            renderOption={(props, option) => (
              <MenuItem sx={{ textTransform: 'capitalize' }} {...props}>
                {option}
              </MenuItem>
            )}
            sx={{ textTransform: 'capitalize' }}
            size="small"
          />
        </FormControl> */}
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="Start date"
            value={filters.startDate}
            onChange={handleFilterStartDate}
            inputFormat="DD MMM YYYY"
            renderInput={(params) => (
              <TextField
                size="small"
                {...params}
                sx={{
                  minWidth: 180,
                }}
              />
            )}
          />
        </LocalizationProvider>

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="End date"
            value={filters.endDate}
            onChange={handleFilterEndDate}
            inputFormat="DD MMM YYYY"
            renderInput={(params) => (
              <TextField
                size="small"
                {...params}
                error={dateError}
                sx={{
                  minWidth: 180,
                }}
              />
            )}
          />
        </LocalizationProvider>

        <Stack direction="row" alignItems="center" spacing={2} flexGrow={1} sx={{ width: 1 }}>
          <TextField
            size="small"
            fullWidth
            value={filters.globalFilter}
            onChange={handleGlobalFilter}
            placeholder="Search..."
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled' }} />
                </InputAdornment>
              ),
            }}
          />
          <ProtectedComponent permission={'CREATE_PROJECT'}>
            <IconButton onClick={popover.onOpen}>
              <Iconify icon="eva:more-vertical-fill" />
            </IconButton>
          </ProtectedComponent>
        </Stack>
      </Stack>
      <CustomPopover
        open={popover.open}
        onClose={popover.onClose}
        arrow="right-top"
        sx={{ width: 140, mt: 1.5, gap: 1 }}
      >
        <MenuItem onClick={handlePopoverOpen}>
          <Iconify icon="material-symbols:info-outline" />
          Info
        </MenuItem>
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handlePopoverClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          <Typography sx={{ p: 2 }}>
            Download the template for correct format:
            <br />
            1. Click 'Download Template' to get the file format for tasks/issues.
            <br />
            2. Fill out your content in the downloaded file.
            <br />
            3. Upload the filled file using 'Upload File' button.
            <br />
            <br />
            Note: Remove time from Start Date and End Date fields to keep only the date.
          </Typography>
        </Popover>

        <Tooltip title="Template To Upload Tasks/Issues">
          <MenuItem onClick={handleExportData}>
            <Iconify icon="solar:import-bold" />
            Import
          </MenuItem>
        </Tooltip>

        <Tooltip title="Upload File For Creating Tasks/Issues">
          <MenuItem onClick={handleIconClick} disabled={loading}>
            {loading ? (
              <CircularProgress size={24} style={{ marginRight: 8 }} />
            ) : (
              <Iconify icon="solar:export-bold" style={{ marginRight: 8 }} />
            )}
            Upload File
            <input
              type="file"
              accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              onChange={handleFileUpload}
              ref={fileInputRef}
              style={{ display: 'none' }}
            />
          </MenuItem>
        </Tooltip>
      </CustomPopover>
    </>
  );
};

export default ProjectListToolbar;
